export const EXAMPLE_QUESTIONS = [
  {
    q: "How did God create the world?",
    label: "Creation",
    image: "https://images.unsplash.com/photo-1588632205848-5789a592134b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    q: "How did Moses part the Red Sea?",
    label: "Exodus",
    image: "https://images.unsplash.com/photo-1547235001-d703406d3f17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "md:col-span-1",
  },
  {
    q: "What is the meaning of Proverbs 3:5?",
    label: "Wisdom",
    image: "https://images.unsplash.com/photo-1508169351866-777fc0047ac5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "md:col-span-1",
  },
  {
    q: "Why did Jesus tell the parable of the prodigal son?",
    label: "Parables",
    image: null,
    span: "md:col-span-1",
  },
  {
    q: "What does the Bible say about forgiveness?",
    label: "Grace",
    image: null,
    span: "md:col-span-1",
  },
];

export const MORE_QUESTIONS = [
  "Who was David and how did he defeat Goliath?",
  "What happened at the Last Supper?",
  "What is the meaning of the Beatitudes?",
  "Why did Noah build the ark?",
  "What does love mean in 1 Corinthians 13?",
  "How should I pray according to Jesus?",
];
